import { createTheme } from '@mui/material'

const getTheme = (mode) =>
  createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: {
        fontSize: '2.5rem',
        '@media (min-width:600px)': {
          fontSize: '3.5rem',
        },
      },
      h2: {
        fontSize: '2rem',
        '@media (min-width:600px)': {
          fontSize: '2.5rem',
        },
      },
      h6: {
        fontSize: '1.1rem',
        '@media (min-width:600px)': {
          fontSize: '1.25rem',
        },
      },
      body1: {
        fontSize: '0.875rem',
        '@media (min-width:600px)': {
          fontSize: '1rem',
        },
      },
      body2: {
        fontSize: '0.8125rem',
        '@media (min-width:600px)': {
          fontSize: '0.875rem',
        },
      },
    },
    palette: {
      mode,
      primary: {
        main: '#6f00ff',
        light: '#6f00ff',
        dark: '00a8e0',
      },
      secondary: {
        main: '#6f00ff',
        light: '#6f00ff',
        dark: '#00a8e0',
      },
      error: {
        main: '#d32f2f',
      },
      background: {
        default: mode === 'light' ? '#ffffff' : '#121212',
        paper: mode === 'light' ? '#f5f5f5' : '#1e1e1e',
      },
      text: {
        primary: mode === 'light' ? '#333333' : '#ffffff',
        secondary: mode === 'light' ? '#6f00ff' : '#b3b3b3',
      },
      divider: mode === 'light' ? '#e0e0e0' : '#2d2d2d',
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            '@media (max-width:600px)': {
              width: '100%',
              marginTop: '8px',
            },
          },
          contained: {
            boxShadow: 'none',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 12,
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              borderRadius: 8,
            },
          },
        },
      },
      MuiContainer: {
        styleOverrides: {
          root: {
            '@media (max-width:960px)': {
              padding: '0',
            },
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            '& .MuiTabs-scrollButtons': {
              '&.Mui-disabled': {
                opacity: 0,
              },
            },
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            '& .MuiIconButton-root': {
              color: mode === 'light' ? '#333333' : '#ffffff',
            },
          },
        },
      },
    },
  })

export { getTheme }
export default getTheme
